import { Component, OnInit } from '@angular/core';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { ComandoMapeamento, Recurso } from '../../../../types/smartinteg';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-mapeamento-list',
  templateUrl: './mapeamento-list.component.html',
  styleUrls: ['./mapeamento-list.component.css'],
  providers: [ConfirmationService]
})
export class MapeamentoListComponent implements OnInit {

  mapeamentos: ComandoMapeamento[] = [];
  recursos: Recurso[] = [];
  loading: boolean = true;

  displayDialog: boolean = false;
  selectedMapeamento: ComandoMapeamento | null = null;

  constructor(
    private smartintegService: SmartintegService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.carregarMapeamentos();
    this.carregarRecursos();
  }

  carregarMapeamentos(): void {
    this.loading = true;
    this.smartintegService.listarMapeamentos().subscribe({
      next: (data) => {
        this.mapeamentos = data;
        this.loading = false;
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao carregar mapeamentos.');
        this.loading = false;
      }
    });
  }

  carregarRecursos(): void {
    this.smartintegService.listarRecursos().subscribe({
      next: (data) => this.recursos = data
    });
  }

  deletarMapeamento(mapeamento: ComandoMapeamento): void {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja deletar o mapeamento <strong>${mapeamento.nome}</strong>?`,
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // Lógica de deleção
      }
    });
  }

  verMapeamento(mapeamento: ComandoMapeamento): void {
    this.selectedMapeamento = mapeamento;
    this.displayDialog = true;
  }

  getMapeamentosArray(mapeamentos: { [key: string]: any }): any[] {
    if (!mapeamentos) return [];
    return Object.keys(mapeamentos).map(key => ({ destino: key, origem: mapeamentos[key] }));
  }
}
